import {
  useGameReducer,
  GameContext,
  GameDispatchContext,
} from "app/game/useGame";

export default function GameStateProvider(props: React.PropsWithChildren) {
  const [roundState, dispatch] = useGameReducer();
  return (
    <GameContext value={roundState}>
      <GameDispatchContext value={dispatch}>
        {props.children}
      </GameDispatchContext>
    </GameContext>
  );
}
